var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orAccountManagement"},[_vm._v("机构账号")])
}
var staticRenderFns = []

export { render, staticRenderFns }